import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { investingService } from '../../services/investingService';

export const useGetInvestedInGroupsStats = () => {
  return useQuery({
    staleTime: 1000 * 10,
    refetchOnWindowFocus: true,
    queryKey: [QUERY_KEYS.investing.invested_in_groups_stats],
    queryFn: () =>
      investingService.investedInGroupsStats().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
